<template>
  <div style="background: #f6f8f8" id="MarkQuestionnaire" v-loading="loading" :element-loading-text="loadingText">
    <div style="width: 100%; height: 78px"></div>
    <div class="dialog_title">
      <div class="t_center">
        <div class="left_logo">
          <span><img class="logo" :src="logoImageUrl" alt="" />{{ title }}</span>
          <span class="left_border">评阅学员[{{ studentName }}]的问卷</span>
        </div>
        <span class="exit_mark" @click="closeMark"><i class="i_exit"></i><span>退出评阅</span></span>
      </div>
    </div>
    <!-- 滚动区域 -->
    <div class="exam_centre">
      <div class="left_box container" ref="container" @scroll="handleScroll" :style="{ height: scrollHeight + 'px' }">
        <!-- 试卷标题 -->
        <div class="exam_title white_bg">
          问卷名称：{{ titleNew? titleNew : '未设置'}}
        </div>
        <div class="question_content white_bg">
          <!-- 这里是内容区域 -->
          <div class="wrapper">
            <div v-for="(section, index) in examPaper.questionnaireAnswerDtos" :key="index" ref="itemRefs"
              :id="'section-' + index">
              <p style="margin-top: 20px">
                {{ convertToChineseNumeral(index + 1) }}、{{
                  section.title
                }}&nbsp;<span class="blue">[{{ section.types == 1 ? '单选题' : section.types == 2 ? '多选题' : '问答题'
}}]</span><span style="color:red;">{{ section.types == 5 ? `（${section.answerJsonDetailDtos[0].score}分）`
  : '' }}</span>
              </p>
              <div class="single_choice question_li">
                <div v-viewer>
                  <!-- 单选、多选-->
                  <div v-if="(section.types === 1 || section.types === 2)">
                    <SelectsType :item="section" :subjectType="section.types"></SelectsType>
                  </div>
                  <!-- 问答题-->
                  <div v-if="section.types === 5">
                    <AnswersType :item="section" :subjectType="section.types"></AnswersType>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_box white_bg">
        <div class="student_score">答题卡</div>
        <div class="tips">
          注：橙色背景为问答题，问答题才能手动评分！
        </div>
        <!-- 答题卡 -->
        <div class="answer_sheet">
          <div>
            <ul class="ans_card">
              <li :class="item.types == 5 ? 'wd' : ''" v-for="(item, index) in examPaper.questionnaireAnswerDtos"
                :key="index" @click="scrollToSection(index)">
                <el-tooltip content="问答题：需手动评分，点击到达指定试题位置" v-if="item.types == 5">
                  <div>{{ index + 1 }}<br />{{ item.score }}分</div>
                </el-tooltip>
                <el-tooltip content="点击到达指定试题位置" v-else>
                  <div>{{ index + 1 }}<br/>{{ item.score }}分</div>
                </el-tooltip>
              </li>
            </ul>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="ft_btn">
          <el-tooltip placement="top">
            <div slot="content" class="tip">
              友情提示：<br />提交评阅:评阅结果提交成功后需要手动刷新后台【问卷调查统计页】才能更新评阅状态！
            </div>
            <el-button class="submit_btn" @click="submintMark">提交评阅</el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- 退出评阅弹窗 -->
    <el-dialog title="退出评阅？" center :visible.sync="dialogVisible" width="25%" top="18vh" :show-close="false">
      <div style="text-align: center">
        亲，退出评阅将不会保存当前评阅记录哦！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exit">退出</el-button>
        <el-button type="primary" @click="dialogVisible = false">继续评阅</el-button>
      </span>
    </el-dialog>
    <!-- 考评评阅确认说明 -->
    <el-dialog title="考评评阅确认说明" center :visible.sync="dialogResult" width="40%">
      <div style="font-size: 16px; line-height: 28px">
        <p style="color: red">
          注：评阅结果提交成功后需要手动刷新后台【问卷调查统计页】才能更新评阅状态！
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResult = false">取消</el-button>
        <el-button type="primary" v-if="!isDisabled" :disabled="isDisabled" @click="postDataMark">确定!</el-button>
        <el-button type="primary" v-else disabled>提交中<i class="el-icon-loading"></i></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetQuestionnaireStudentAnswerDto,
  CheckQuestionnaireStudent,
} from "network/createSurvey";
import { convertToChineseNumeral } from "common/utils";
import SelectsType from "./component/SelectsType";
import AnswersType from "./component/AnswersType";
import { defaultThemeStyle } from "common/const";

export default {
  name: "MarkQuestionnaire",
  components: {
    SelectsType,
    AnswersType,
  },
  data() {
    return {
      isDisabled: false,
      radio: "1", //是否评分
      scrollHeight: document.body.clientHeight - 88, //滚动高度
      container: null, // 获取滚动容器
      scrollPosition: 0,
      itemHeight: [],
      stickyStyle: { position: "absolute" }, //初始位置
      stickyHeight: 68,
      borderBlue: {
        borderBottom: "1px solid #ebeced",
        width: "864px",
        margin: "20px 20px 0 20px",
      },
      grayBoxShow: false, //是否展示吸顶后右侧灰色
      dialogVisible: false, //退出评阅弹窗
      score: 0,
      activeTab: 1,
      examPaper: {}, //试卷内容
      typeList: [], //题目类型
      subjectsList: [], //试卷下试题组
      isPush: true, //是否公布
      isSendWxMsg: true, //是否发送微信消息
      examinationStudentId: "",
      arrtypes1: [],
      arrtypes2: [],
      arrtypes3: [],
      arrtypes4: [],
      arrtypes5: [],
      arrtypes6: [],
      arrtypes7: [],
      arrtypes8: [],
      arrtypes9: [],
      arrtypes10: [],
      arrtypes11: [],
      dialogResult: false,
      loading: false,
      loadingText: 'loading...',
      studentName:''
    };
  },
  computed: {
    logoImageUrl() {
      if (this.$store.state.allConfig) {
        return this.$store.state.allConfig.logoAdminImageUrl;
      } else if (sessionStorage.getItem("allConfig")) {
        return JSON.parse(sessionStorage.getItem("allConfig"))
          .logoAdminImageUrl;
      } else {
        return "";
      }
    },
    title() {
      if (this.$store.state.allConfig) {
        return this.$store.state.allConfig.projectName;
      } else if (sessionStorage.getItem("allConfig")) {
        return JSON.parse(sessionStorage.getItem("allConfig")).projectName;
      } else {
        return "";
      }
    },
    userScore() {
      const paseint = /^\+?[1-9][0-9]*$/; //正整数
      if (this.subjectsList && this.subjectsList.length > 0) {
        this.subjectsList.forEach((e) => {
          if (e.key.types == 1) {
            let teacherScore1 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore1 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore1) && teacherScore1 > 0
              ? (e.subTeacherScoreTotal = teacherScore1.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore1);
          }
          if (e.key.types == 2) {
            let teacherScore2 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore2 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore2) && teacherScore2 > 0
              ? (e.subTeacherScoreTotal = teacherScore2.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore2);
          }
          if (e.key.types == 3) {
            let teacherScore3 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore3 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore3) && teacherScore3 > 0
              ? (e.subTeacherScoreTotal = teacherScore3.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore3);
          }
          if (e.key.types == 4) {
            let teacherScore4 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore4 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore4) && teacherScore4 > 0
              ? (e.subTeacherScoreTotal = teacherScore4.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore4);
          }
          if (e.key.types == 5) {
            let teacherScore5 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore5 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore5) && teacherScore5 > 0
              ? (e.subTeacherScoreTotal = teacherScore5.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore5);
          }
          if (e.key.types == 6) {
            let teacherScore6 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore6 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore6) && teacherScore6 > 0
              ? (e.subTeacherScoreTotal = teacherScore6.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore6);
          }
          if (e.key.types == 7) {
            let teacherScore7 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore7 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore7) && teacherScore7 > 0
              ? (e.subTeacherScoreTotal = teacherScore7.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore7);
          }
          if (e.key.types == 8) {
            let teacherScore8 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore8 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore8) && teacherScore8 > 0
              ? (e.subTeacherScoreTotal = teacherScore8.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore8);
          }
          if (e.key.types == 9) {
            let teacherScore9 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore9 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore9) && teacherScore9 > 0
              ? (e.subTeacherScoreTotal = teacherScore9.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore9);
          }
          if (e.key.types == 10) {
            let teacherScore10 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore10 += Number(i.teacherScore);
              }
            });
            !paseint.test(teacherScore10) && teacherScore10 > 0
              ? (e.subTeacherScoreTotal = teacherScore10.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore10);
          }
          if (e.key.types == 11) {
            let teacherScore11 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore11 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore11) && teacherScore11 > 0
              ? (e.subTeacherScoreTotal = teacherScore11.toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore11);
          }
        })
        // 总分
        let sum = 0;
        this.subjectsList.forEach((e) => {
          e.value.forEach((item) => {
            let teacherScore = !paseint.test(item.teacherScore) && item.teacherScore > 0
              ? item.teacherScore.toFixed(2)
              : item.teacherScore;
            sum += Number(teacherScore);
          })
        })
        return sum.toFixed(2);
      }
    },
  },
  watch: {
  },
  created() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
    });
    setTimeout(() => {
      loading.close();
    }, 500);
    let query = this.getQueryParams(); //参数部分
    if (query) {
      this.questionnaireStudentId = query.questionnaireStudentId;
      this.titleNew = query.title
      this.loading = true;
      this.studentName = query.studentName
      this.getQuestionnaire(this.questionnaireStudentId);
    }
  },
  mounted() {
    let style;
    if (
      this.$store.state &&
      this.$store.state.themeStyle &&
      this.$store.state.themeStyle.ThemeColor
    ) {
      style = JSON.parse(this.$store.state.themeStyle);
    }
    if (sessionStorage.getItem("themeStyle")) {
      style = JSON.parse(sessionStorage.getItem("themeStyle"));
    } else {
      style = defaultThemeStyle;
    }
    this.$nextTick(() => {
      document
        .querySelector("body")
        .setAttribute(
          "style",
          `--ThemeColor: ${style.ThemeColor || "#fd5252"};`
        );
    });
  },
  methods: {
    // 调用阿拉伯数字转中文数字方法
    convertToChineseNumeral,
    // 获取浏览器地址栏问号后的参数部分
    getQueryParams() {
      const queryParams = {};
      const hash = window.location.hash;
      const queryString = hash.substring(hash.indexOf('?') + 1); // 提取问号后的部分

      if (!queryString) {
        return queryParams; // 如果没有查询参数，直接返回空对象
      }
      const queryArray = queryString.split("&");
      for (let i = 0; i < queryArray.length; i++) {
        const keyValue = queryArray[i].split("=");
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1] || "");
        queryParams[key] = value;
      }
      return queryParams;
    },
    // 获取待评阅考试记录
    async getQuestionnaire(id) {
      const res = await GetQuestionnaireStudentAnswerDto(id);
      if (res && res.code == 1) {
        this.examPaper = res.result; //试卷内容
        this.container = this.$refs.container;
        this.$nextTick(() => {
          this.loading = false
          this.loadingText = "加载中...";
        })
      } else {
        this.$alert(res.message);
        this.$nextTick(() => {
          this.loading = false
        })
      }
    },
    // 退出评阅
    closeMark() {
      this.dialogVisible = true;
    },
    //退出
    exit() {
      window.close();
    },
    submintMark() {
      this.dialogResult = true;
    },

    //提交评阅
    postDataMark() {
      this.dialogResult = false;
      this.submitPost();
    },
    async submitPost() {
      let checkQuestionnaireAnswerDtos = []
      let obj
      this.examPaper.questionnaireAnswerDtos.forEach((e) => {
        obj = {
          subjectId: e.subjectId,
          score: e.score
        }
        checkQuestionnaireAnswerDtos.push(obj)
      })
      let data = {
        questionnaireStudentId: this.questionnaireStudentId,
        checkQuestionnaireAnswerDtos: checkQuestionnaireAnswerDtos
      };
      this.isDisabled = true;
      const res = await CheckQuestionnaireStudent(data);
      this.isDisabled = false;
      if (res && res.code == 1) {
        this.$alert(res.message, "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          window.close();
        });
      } else {
        this.$alert(res.message, "提示", {
          confirmButtonText: "确定",
        }).then(() => { });
      }
    },
    //题目区域滚动
    handleScroll() {
      this.scrollPosition = this.container.scrollTop; //滚动高度
    },
    // 锚点滚动
    scrollToSection(index) {
      let selectElementHeight = document.querySelector(
        `#section-${index}`
      ).offsetTop; // 要跳转元素到offsetParent顶部的距离
      console.log(selectElementHeight, 'selectElementHeight', this.stickyHeight);
      this.container.scrollTo({
        top: selectElementHeight - this.stickyHeight,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
@import url("./markQuestionnaire.css");

#MarkQuestionnaire ::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

#MarkQuestionnaire ::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

#MarkQuestionnaire ::v-deep el-input {
  z-index: -1;
}

.ft_btn>>>.el-button {
  width: 90%;
  line-height: 24px;
  margin: 0 auto;
  border-radius: 60px;
  color: #333;
  background-color: var(--ThemeColor, #ffae02);
}

.ft_btn>>>.el-button:hover {
  color: #fff;
  background-color: var(--ThemeColor, #ffae02);
}

.two_checkbox::v-deep .el-checkbox__label {
  color: var(--ThemeColor);
}

.two_checkbox::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.two_checkbox::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  color: var(--ThemeColor);
  background-color: var(--ThemeColor);
  border-color: var(--ThemeColor);
}
</style>